module.exports = __webpack_public_path__ + "static/media/whatsapp1.30bb6ee8.jpg";